module.exports = __webpack_public_path__ + "site-82.jpg?6bd14caefe38563a3bcb8d7c9eedbfda";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-82.jpg
 ** module id = 194
 ** module chunks = 0
 **/